import { render, staticRenderFns } from "./deviceOldLocationList.vue?vue&type=template&id=4c0c87ef&scoped=true"
import script from "./deviceOldLocationList.vue?vue&type=script&lang=js"
export * from "./deviceOldLocationList.vue?vue&type=script&lang=js"
import style0 from "./deviceOldLocationList.vue?vue&type=style&index=0&id=4c0c87ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c87ef",
  null
  
)

export default component.exports